import React, { useState, useEffect } from "react";
import { PhotoIcon, TrashIcon } from "@heroicons/react/24/solid";
import { authAxios } from "../../config/config";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { correctContactValue } from "../../Helper/helper";

const AddTrading = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const [formData, setFormData] = useState({
    title: { en: "", ar: "" },
    description: { en: "", ar: "" },
    tradingCategory: "",
    image: [],
    price: "",
    discountUrl: "",
    website: "",
    contactNumber: ""
  });
  const currentlanguage = i18next.language
  const [allTradingCategory, setallTradingCategory] = useState([])

  const handleInputChange = (field, lang, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === "object" ? value : { ...prev[field], [lang]: value },
    }));
  };

  const fetchTradingData = async () => {

    try {
      const response = await authAxios().get(
        `/admin/trading-category`
      );

      const resData = response?.data;

      setallTradingCategory(resData.data.tradingCategories)

    } catch (error) {

      toast.error(error?.response?.data?.message);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };

    console.log("payload", payload)
    if (allmodel?.data?._id) {
      handleUpdate(payload);
    } else {
      handleAdd(payload);
    }
  };

  const handleProfileChange = async (field, files) => {
    const uploadedImages = [];
    const uploadPromises = Array.from(files).map(async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await authAxios().post("/admin/upload/single", formData);
        uploadedImages.push(response.data.data.url);
        toast.success("Image uploaded successfully!");
      } catch (error) {
        toast.error("Failed to upload image.");
      }
    });

    await Promise.all(uploadPromises);

    setFormData((prev) => ({
      ...prev,
      [field]: [...(prev[field] || []), ...uploadedImages]
    }));
  };


  useEffect(() => {
    fetchTradingData()
    if (allmodel?.data?._id) {
      setFormData({
        title: allmodel.data.title,
        description: allmodel.data.description,
        tradingCategory: allmodel.data.tradingCategory?._id,
        image: allmodel.data.image,
        price: allmodel.data.price,
        discountUrl: allmodel.data.discountUrl,
        website: allmodel.data.website,
        contactNumber: allmodel.data.contactNumber,
      });
    }
  }, []);

  const handleRemoveImage = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index)
    }));
  };




  return (
    <div className="fixed inset-0 z-10">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
          <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="px-6 py-8">
              <h2 className="text-lg font-medium text-gray-900 mb-6">
                {allmodel?.data?._id ? "Update Trading " : "Add Trading "}
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Title */}
                {["title", "description"].map((field) => (
                  <div key={field} className="flex  gap-4">
                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                    </label>
                    {field === "description" ? (
                      <div className="flex flex-col w-full">
                        <textarea
                          placeholder={`${field} (EN)`}
                          required
                          value={formData[field]?.en || ""}
                          onChange={(e) => handleInputChange(field, "en", e.target.value)}
                          className="mb-4 flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                          rows={5}
                        />
                        <textarea
                          placeholder={`${field} (AR)`}
                          required
                          value={formData[field]?.ar || ""}
                          onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                          rows={5}
                        />
                      </div>
                    ) : (
                      <>
                        <input
                          type="text"
                          placeholder={`${field} (EN)`}
                          required
                          value={formData[field]?.en || ""}
                          onChange={(e) => handleInputChange(field, "en", e.target.value)}
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                        />
                        <input
                          type="text"
                          placeholder={`${field} (AR)`}
                          required
                          value={formData[field]?.ar || ""}
                          onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                        />
                      </>
                    )}
                  </div>
                ))}


                {/* Trading Category */}
                <div className="flex items-center gap-4">
                  <label
                    htmlFor="country"
                    className="w-1/4 block text-sm font-medium text-gray-700 text-justify"
                  >
                    Select Category
                  </label>
                  <select
                    required
                    id="category"
                    value={formData.tradingCategory} // Correct field
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, tradingCategory: e.target.value }))
                    }
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  >
                    <option value="">-- Select a Category --</option>
                    {allTradingCategory &&
                      allTradingCategory.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category?.name[currentlanguage]}
                        </option>
                      ))}
                  </select>


                </div>

                {/* Price */}
                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Price</label>
                  <input
                    type="number"
                    placeholder="Price"
                    value={formData.price || ""}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                    required
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />
                </div>

                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                  <input
                    type="text"
                    placeholder="Contact Number"

                    value={formData.contactNumber}
                    onChange={(e) => setFormData({ ...formData, contactNumber: correctContactValue(e.target.value) })}
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />

                </div>

                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Website</label>
                  <input
                    type="link"
                    placeholder="Enter website"
                    value={formData.website}
                    onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />

                </div>

                {/* Discount URL */}
                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Discount URL</label>
                  <input
                    type="url"
                    placeholder="Discount URL"
                    value={formData.discountUrl || ""}
                    onChange={(e) => setFormData({ ...formData, discountUrl: e.target.value })}

                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />
                </div>

                {/* Image Upload */}
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-3">
                    <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-900 mb-2 text-justify">Image</label>

                  </div>
                  <div className="col-span-9">
                    {formData.image.length === 0 ? (
                      <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                        <PhotoIcon aria-hidden="true" className="text-gray-300 h-12 w-12 mb-2" />
                        <div className="flex items-center text-sm text-gray-600">
                          <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500">
                            <span>Upload a file</span>
                            <input
                              id="file-upload"
                              name="file-upload"
                              type="file"
                              multiple
                              required
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleProfileChange("image", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                          <p className="pl-2">or drag and drop</p>
                        </div>
                        <p className="mt-2 text-xs text-gray-500">PNG, JPG, JPEG up to 10MB</p>
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-4">
                        {formData.image.map((url, index) => (
                          <div key={index} className="relative w-1/2 sm:w-1/3 lg:w-1/4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${url}`}
                              className="w-full h-40 object-cover rounded-lg sm:h-32 lg:h-48"
                            />
                            <div onClick={() => handleRemoveImage("image", index)} className="absolute top-2 right-2 z-10">
                              <TrashIcon className="h-6 w-6 text-gray-700 cursor-pointer" />
                            </div>
                          </div>
                        ))}
                        <div className="w-1/2 sm:w-1/3 lg:w-1/4 flex items-center justify-center">
                          <label
                            htmlFor="file-upload"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Add Image</span>
                            <input
                              id="file-upload"
                              name="file-upload"
                              type="file"
                              multiple
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleProfileChange("image", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Submit Buttons */}
                <div className="flex gap-2 mt-4">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="w-1/2 text-sm font-semibold text-gray-900 bg-gray-200 px-4 py-3 rounded-md shadow-sm hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-1/2 text-sm font-semibold text-white bg-indigo-600 px-4 py-3 rounded-md shadow-sm hover:bg-indigo-700"
                  >
                    {allmodel?.data?._id ? "Update" : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTrading;
